import React, { useCallback, useState } from "react";
import IconFont from "@/components/icon";

import { isFocusEnv, IFocusSDK } from "@/utils";

type AppFrameType = "min" | "max" | "unMax" | "hide" | "close";
const MinIcon = <IconFont type="iconwin_Minimize" />;
const MaxIcon = <IconFont type="iconwin_Full" />;
const WinIcon = <IconFont type="iconwin_window" />;
const CloseIcon = <IconFont type="iconwin_Close" />;

export default function WinToolbar({
  FocusSDK,
  title = ""
}: {
  FocusSDK: IFocusSDK;
  title?: string;
}) {
  const [isMax, setIsMax] = useState(isFocusEnv() ? FocusSDK?.getWindowFrame("max") : "");

  const onItemClick = useCallback(
    (appFrame: AppFrameType, window?: string) => {
      FocusSDK.setWindowFrame(appFrame, window);
      setTimeout(() => {
        setIsMax(FocusSDK.getWindowFrame("max"));
      }, 0);
    },
    [FocusSDK]
  );

  const handleClose = useCallback(() => {
    onItemClick("close");
  }, [onItemClick]);

  function onToolbarContextMenu() {
    if (FocusSDK.isBeta()) {
      FocusSDK.openDevTools();
    }
  }
  return (
    <div className="ele-modal-tool-bar-wrapper" onContextMenu={onToolbarContextMenu}>
      <div className="ele-modal-tool-bar-title">{title}</div>
      <div className="ele-modal-tool-bar-btns">
        <div
          role="button"
          className="winToolItem"
          onClick={() => {
            onItemClick("min");
          }}
        >
          {MinIcon}
        </div>
        <div
          className="winToolItem"
          role="button"
          onClick={() => {
            onItemClick(isMax ? "unMax" : "max");
          }}
        >
          {FocusSDK.getWindowFrame("max") ? WinIcon : MaxIcon}
        </div>
        <div className="winToolItem" role="button" onClick={handleClose}>
          {CloseIcon}
        </div>
      </div>
    </div>
  );
}
